import React, { Component } from 'react';
import { Modal, Form, InputNumber } from 'antd';
import { inject, observer } from 'mobx-react/index';

@inject('store')
@observer
export class LimitSellModal extends Component {
    constructor(props) {
        super(props);
        this.form = React.createRef();
    }

    render() {
        const position = this.props.position;
        return (
            <Modal
                title="Limit Sell"
                width={250}
                visible={this.props.visible}
                onCancel={() => {
                    this.form.current.resetFields();
                    this.props.onCancel();
                }}
                onOk={() => {
                    this.form.current.validateFieldsAndScroll((err, values) => {
                        if (!err) {
                            this.props.store.botStore.actionStore.execute('user_sell', {
                                position_id: position.id,
                                price: values.price
                            });
                            this.form.current.resetFields();
                            this.props.onCancel();
                        }
                    });
                }}
            >
                <LimitSellForm ref={this.form} position={this.props.position} />
            </Modal>
        );
    }
}

@inject('store')
@observer
class LimitSellFormComponent extends Component {
    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        const position = this.props.position;
        const enteredPrice = getFieldValue('price') || position.current_price;

        if (!position) return null;
        return (
            <Form>
                <b>Breakeven Price: </b>
                <span style={{ fontSize: 13 }}>
                    {(parseFloat(position.breakeven_price) || 0).toFixed(8)}
                </span>
                <br />
                <b>Result: </b>
                <span style={{ fontSize: 13 }}>
                    {(
                        ((enteredPrice - parseFloat(position.breakeven_price)) /
                            parseFloat(position.breakeven_price)) *
                        100
                    ).toFixed(4)}
                    %
                </span>
                <Form.Item label="Price" required={true}>
                    {getFieldDecorator('price', {
                        initialValue: position.current_price,
                        rules: [{ required: true, message: 'Field is required' }]
                    })(
                        <InputNumber
                            style={{ width: '100%' }}
                            step={(position.breakeven_price / 1000).toFixed(8)}
                        />
                    )}
                </Form.Item>
            </Form>
        );
    }
}

export const LimitSellForm = Form.create()(LimitSellFormComponent);



// WEBPACK FOOTER //
// ./src/Account/Bot/PositionsView/LimitSellModal.js